import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { ArrowDownward, Block, Save } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import RevenueExpenditureCreateOrEdit from "app/Management/ManageConcept/RevenueExpenditure/RevenueExpenditureCreateOrEdit";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import Config, {
  EXCLUDE_QUIT_STAFF,
  PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import IconDelete from "app/common/Icon/IconDelete";
import {
  GENUS_TYPE,
  LEAD_SOURCE_LEVEL,
  PathModule,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
} from "app/common/LocalConst";
import {
  config_resizeImg,
  getDepartmentsUser,
  getPositionCodes,
  isAdmin,
  transformDate,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
  validateVoucherPaymentMethods,
} from "app/common/LocalFunction";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { uploadFile } from "app/services/FileDescriptionExtService";
import { pagingPosition } from "app/services/PositionService";
import { pagingRevenueExpenditure } from "app/services/RevenueExpenditureService";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import imageCompression from "browser-image-compression";
import { FieldArray, getIn, useFormikContext } from "formik";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgRotate from "lightgallery/plugins/rotate";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import LightGallery from "lightgallery/react";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import TotalOfVoucherTypeCash from "../Component/TotalOfVoucherTypeCash";
const PaymentVoucherPopup = ({
  open,
  handleClose,
  initialPaymentVoucher,
  handleSubmit,
  listPaymentMethod,
  listStk,
  listPos,
  listPos_tragop,
  listHomecredit,
  handleAfterSubmit,
  isSingleVoucher = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const defaultDepartment = useDefaultDepartment();

  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    accountant: Yup.object().nullable().required("Chưa có người chi!"),
    voucherDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày chi chưa đúng định dạng!")
      .nullable(),
    voucherPaymentMethods: Yup.array().of(
      Yup.object()
        .shape()
        .test(
          "Validate voucher bank",
          "Bắt buộc chọn stk",
          validateVoucherPaymentMethods
        )
    ),
    totalAmount: Yup.number()
      .nullable()
      .transform((_, originalValue) => {
        if (typeof originalValue === "string") {
          return Number(originalValue.replaceAll(",", ""));
        }
        return originalValue;
      })
      .min(1, "Số tiền chi phải lớn hơn 0!")
      .test(
        "not-exceed-total-paid",
        "Số tiền chi không được lớn hơn số tiền đã thu!",
        function (value) {
          if (isSingleVoucher) return true;
          const parent = this.parent;

          const totalPaid =
            Number(parent?.treatmentPlanCard?.totalBillPatientPaid) ||
            Number(parent?.patientServiceRegister?.totalBillPatientPaid) ||
            Number(parent?.drugOrder?.totalBillPatientPaid) ||
            0;

          if (value == null) return true;

          return value <= totalPaid;
        }
      ),
    staffRevenues: Yup.array()
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object().nullable(),
            actualAmount: Yup.number()
              .min(0, "Tiền phân bổ phải lớn hơn 0!")
              .nullable(),
            percentRevenue: Yup.number()
              .nullable()
              .min(0, "Tối thiểu 0%")
              .max(100, "Tối đa 100%"),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )
      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),
  });

  return (
    <PopupForm
      open={open}
      size="xl"
      // height="75vh"
      handleClose={handleClose}
      title={"Tạo phiếu chi"}
      formik={{
        initialValues: {
          ...initialPaymentVoucher,
          department: defaultDepartment,
          attachmentIds: [],
          attachmentIdsPreview: [],
        },
        onSubmit: async (values, { setSubmitting }) => {
          await handleSubmit(values, { setSubmitting });
          if (handleAfterSubmit) {
            handleAfterSubmit();
          }
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting}>
              {!isMobile && <Save className="mr-2 " />}
              Tạo phiếu chi
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listStk={listStk}
              listPaymentMethod={listPaymentMethod}
              listPos={listPos}
              listHomecredit={listHomecredit}
              listPos_tragop={listPos_tragop}
            />
            <DialogError values={values} setFieldValue={setFieldValue} />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ listStk, listPaymentMethod, listPos, listHomecredit, listPos_tragop }) => {
    const { initialPatient } =
      useStore().patientManagementStore.patientGeneralStore;
    const { values, setFieldValue } = useFormikContext();
    let POSITION_CODES = getPositionCodes();
    const { handleOpenFormCreateOrEdit } =
      useStore().managementStore.revenueExpenditureStore;
    const { getListProperties } = useStore().feeStore.serviceFeeTabStore;
    const infoItem = values?.treatmentPlanCard
      ? values?.treatmentPlanCard?.clientCard?.name
      : values?.drugOrder
      ? values?.drugOrder?.drugName
      : values?.patientServiceRegister
      ? values?.patientServiceRegister?.service?.name
      : "";

    const isAdminPermission = isAdmin();
    const departmentsUser = getDepartmentsUser();
    return (
      <>
        {/* <FormikFocusError /> */}
        {console.log("values", values)}

        <section className="cards-container">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={1}
                style={{ backgroundColor: "aliceblue" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="payment-info"
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "baseline",
                  }}
                >
                  <div>
                    <div className="flex gap-1">
                      <span className="info-label">Khách hàng :</span>
                      <span className="info-value">
                        <p>
                          <b>{initialPatient?.patientInfo?.displayName}</b>
                          {" - "}
                          <b style={{ color: "#4276a4" }}>
                            {initialPatient?.patientInfo?.code}{" "}
                          </b>
                        </p>
                      </span>
                    </div>
                    <span className="info-label">Phiếu chi cho :</span>
                    <span className="info-value"> {infoItem}</span>
                  </div>
                  <div className="info-label flex gap-2 align-center">
                    Không trừ doanh thu :
                    <div>
                      <GlobitsCheckBox name="isNotRevenueDeducted" />
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsPagingAutocomplete
                    name={"department"}
                    label={"Cơ sở"}
                    api={
                      isAdminPermission
                        ? pagingDepartment
                        : async () => ({
                            data: {
                              content: departmentsUser || [],
                              totalElements: departmentsUser?.length || 0,
                              totalPages: 1,
                            },
                          })
                    }
                    required
                    onChange={async (_, department) => {
                      setFieldValue("department", department);
                      const {
                        listStk,
                        listPos,
                        listPos_tragop,
                        listHomecredit,
                      } = await getListProperties({
                        departmentIds: department ? [department.id] : [],
                      });
                      let voucherPaymentMethods =
                        values?.voucherPaymentMethods?.map((el) => {
                          if (
                            el?.paymentMethodValue?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                          ) {
                            return {
                              ...el,
                              bankName: listStk?.[0]?.propertyName,
                              bankAccountNumber: listStk?.[0]?.property,
                              paymentBank: listStk?.[0],
                            };
                          }
                          if (
                            el?.paymentMethodValue?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_POS
                          ) {
                            return {
                              ...el,
                              bankName: listPos?.[0]?.propertyName,
                              bankAccountNumber: listPos?.[0]?.property,
                              paymentBank: listPos?.[0],
                            };
                          }
                          if (
                            el?.paymentMethodValue?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
                          ) {
                            return {
                              ...el,
                              bankName: listHomecredit?.[0]?.propertyName,

                              bankAccountNumber: listHomecredit?.[0]?.property,
                              paymentBank: listHomecredit?.[0],
                            };
                          }
                          if (
                            el?.paymentMethodValue?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
                          ) {
                            return {
                              ...el,
                              bankName: listPos_tragop?.[0]?.propertyName,
                              bankAccountNumber: listPos_tragop?.[0]?.property,
                              paymentBank: listPos_tragop?.[0],
                            };
                          }
                          return el;
                        });

                      setFieldValue(
                        "voucherPaymentMethods",
                        voucherPaymentMethods
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <GlobitsPagingAutocomplete
                    label="Người chi"
                    name="accountant"
                    displayLabel="staffName"
                    api={pagingStaff}
                    required
                    searchObject={{
                      isActive: true,
                    }}
                    ListboxComponent={forwardRef((props, ref) => {
                      const { children, ...other } = props;
                      return (
                        <ul {...other} ref={ref}>
                          <ol>
                            <li>{children}</li>
                          </ol>
                        </ul>
                      );
                    })}
                    renderOption={(option) => renderOptionsStaff(option)}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <GlobitsDateTimePicker
                    required
                    label="Ngày chi"
                    name="voucherDate"
                    isDateTimePicker
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <GlobitsVNDCurrencyInput
                    label="Số tiền chi"
                    name="totalAmount"
                  />
                </Grid>
                <Grid item xs={12} md={2} className="flex gap-2 align-end">
                  <GlobitsPagingAutocomplete
                    // required
                    name={"budgetCategory"}
                    label="Khoản chi"
                    searchObject={{ type: GENUS_TYPE }}
                    api={pagingRevenueExpenditure}
                    // arrAdd={[{ title: "title" }]}
                    // renderOption={(option) => RenderTable(option)}
                    onChange={(_, value) => {
                      setFieldValue("budgetCategory", value);
                      setFieldValue("note", value?.description);
                    }}
                  />

                  <CommonButton
                    className="btn-primary"
                    onClick={() => handleOpenFormCreateOrEdit(null, GENUS_TYPE)}
                  >
                    <AddIcon />
                  </CommonButton>
                </Grid>
                <Grid item xs={12} md={4}>
                  <GlobitsTextField
                    isTextArea
                    rows={2}
                    label="Lý do /nội dung"
                    name="note"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <ImageUploadPreview name="attachmentIds" label="Hình ảnh" />
                </Grid>
              </Grid>

              <Grid container spacing={1} className="mt-1">
                <Grid item xs={12} md={9}>
                  <Grid container spacing={1}>
                    <StaffRevenues POSITION_CODES={POSITION_CODES} />
                  </Grid>
                </Grid>
                <Grid item xs={12} md={3} className="flex flex-end">
                  <TotalOfVoucherTypeCash
                    listPaymentMethod={listPaymentMethod}
                    listStk={listStk}
                    listPos={listPos}
                    listHomecredit={listHomecredit}
                    listPos_tragop={listPos_tragop}
                    moneyAfterDiscount={values?.totalAmount || 0}
                    nameSpace={"voucherPaymentMethods"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <RevenueExpenditureCreateOrEdit
            handleAfterSubmit={(data) => {
              setFieldValue("budgetCategory", data);
              setFieldValue("note", data?.description || "");
            }}
          />
        </section>
      </>
    );
  }
);

const StaffRevenues = ({ POSITION_CODES }) => {
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    let staffRevenues = values?.staffRevenues?.map((el) => ({
      ...el,
      actualAmount: (values?.totalAmount * el?.percentRevenue) / 100,
    }));
    setFieldValue("staffRevenues", staffRevenues);
  }, [values?.totalAmount]);
  return (
    <FieldArray name="staffRevenues">
      {({ remove, push }) => (
        <>
          <Grid item xs={12} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Nguồn"}
              name="sourceRevenue"
              api={pagingCustomerSource}
              searchObject={{ level: LEAD_SOURCE_LEVEL.LEVEL_2.value }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Chọn chức danh"}
              name="position"
              api={pagingPosition}
              searchObject={{
                isUsing: true,
                positionCodes: POSITION_CODES,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <GlobitsPagingAutocomplete
              disableClearable
              label={"Chọn nhân viên được phân bổ doanh thu"}
              api={pagingStaff}
              name={`staff`}
              displayLabel="staffName"
              autoUpercase
              searchObject={{
                positionId: values?.position?.id,
                isActive: true,
                excludeStatus: EXCLUDE_QUIT_STAFF,
              }}
              getOptionDisabled={(option) => {
                const selectedService = getIn(values, "staffRevenues");
                if (
                  selectedService?.find((it) => it?.staff?.id === option?.id)
                ) {
                  return true;
                }
                return false;
              }}
              ListboxComponent={forwardRef((props, ref) => {
                const { children, ...other } = props;
                return (
                  <ul {...other} ref={ref}>
                    <ol>
                      <li>{children}</li>
                    </ol>
                  </ul>
                );
              })}
              renderOption={(option) => renderOptionsStaff(option)}
            />
          </Grid>
          <Grid item xs={2} className="flex align-end">
            <CommonButton
              onClick={() => {
                push({
                  staff: values?.staff,
                  source: values?.sourceRevenue,
                  position: values?.position
                    ? values?.position
                    : values?.staff?.position,
                  percentRevenue: 100,
                  actualAmount: values?.totalAmount,
                });
                setFieldValue("staff", null);
                setFieldValue("position", null);
              }}
            >
              <ArrowDownward />
            </CommonButton>
          </Grid>

          <Grid item xs={12}>
            <div className="table-root mt-2">
              <div style={{ minWidth: "680px" }}>
                <table className="table-container">
                  <thead>
                    <tr className="row-table-header">
                      <th width="5%">STT</th>
                      <th width="20%">Nguồn</th>
                      <th width="17%">Chức danh</th>
                      <th width="18%">Nhân viên</th>
                      <th width="15%">Phân bổ (%)</th>
                      <th width="15%">Phân bổ (tiền)</th>
                      <th width="10%">Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values?.staffRevenues?.length > 0 &&
                      values?.staffRevenues?.map((item, index) => {
                        let positionName =
                          values?.staffRevenues[index]?.position?.name;
                        let staffName =
                          values?.staffRevenues[index]?.staff?.staffName;

                        if (!positionName) {
                          positionName = "Chưa lựa chọn";
                        }
                        if (!staffName) {
                          staffName = "Chưa lựa chọn";
                        }

                        return (
                          <tr key={index}>
                            <td align="center">{index + 1}</td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingCustomerSource}
                                name={`staffRevenues[${index}].source`}
                                searchObject={{
                                  level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                                }}
                                autoUpercase
                              />
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingPosition}
                                name={`staffRevenues[${index}].position`}
                                autoUpercase
                                searchObject={{
                                  isUsing: true,
                                  positionCodes: POSITION_CODES,
                                }}
                                onChange={function (_, value) {
                                  setFieldValue(
                                    `staffRevenues[${index}].position`,
                                    value
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].staff`,
                                    null
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingStaff}
                                name={`staffRevenues[${index}].staff`}
                                displayLabel={"staffName"}
                                autoUpercase
                                searchObject={{
                                  positionId:
                                    values?.staffRevenues[index]?.position?.id,
                                  isActive: true,
                                  excludeStatus: EXCLUDE_QUIT_STAFF,
                                }}
                                onChange={function (_, value) {
                                  setFieldValue(
                                    `staffRevenues[${index}].staff`,
                                    value
                                  );
                                  const position = getIn(
                                    values,
                                    `staffRevenues[${index}].position`
                                  );
                                  if (!position) {
                                    setFieldValue(
                                      `staffRevenues[${index}].position`,
                                      value?.position
                                    );
                                  }
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsNumberInput
                                name={`staffRevenues[${index}].percentRevenue`}
                                onChange={(e) => {
                                  let percentRevenue = +e?.target?.value;
                                  setFieldValue(
                                    `staffRevenues[${index}].percentRevenue`,
                                    percentRevenue
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].actualAmount`,
                                    (percentRevenue * values?.totalAmount) / 100
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsVNDCurrencyInput
                                name={`staffRevenues[${index}].actualAmount`}
                              />
                            </td>
                            <td align="center">
                              <span
                                tooltip={"Xóa"}
                                className="pointer tooltip"
                                onClick={() => remove(index)}
                              >
                                <IconDelete />
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </Grid>
        </>
      )}
    </FieldArray>
  );
};

const ImageUploadPreview = ({ name }) => {
  const { values, setFieldValue } = useFormikContext();
  const inputRef = useRef();

  const handleChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const currentIds = values[name] || [];
    const currentPreviews = values[`${name}Preview`] || [];

    if (currentIds.length + files.length > PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT) {
      toast.warning(
        `Chỉ được phép tải tối đa ${PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT} ảnh!`
      );
      return;
    }

    try {
      // console.log("Trước khi nén");
      // files.forEach((file) => {
      //   console.log(file.name, file.type, (file.size / 1024).toFixed(2), "KB");
      // });
      const compressedFiles = await Promise.all(
        files.map((file) => imageCompression(file, config_resizeImg))
      );
      // console.log("Sau khi nén");
      // compressedFiles.forEach((blob, idx) => {
      //   console.log(files[idx].name, blob.type, (blob.size / 1024).toFixed(2), "KB");
      // });
      const finalFiles = compressedFiles.map(
        (blob, idx) =>
          new File([blob], files[idx].name, { type: files[idx].type })
      );

      const uploadResponses = await Promise.all(
        finalFiles.map((file) => uploadFile(file))
      );

      const newPreviews = uploadResponses
        .map((res, idx) => {
          const id = res?.data?.id;
          return {
            id,
            url: URL.createObjectURL(finalFiles[idx]),
            digImageDescription: "",
          };
        })
        .filter((item) => item.id);
      setFieldValue(name, [...currentIds, ...newPreviews.map((p) => p.id)]);
      setFieldValue(`${name}Preview`, [...currentPreviews, ...newPreviews]);
    } catch (err) {
      console.error("Lỗi trong quá trình upload nhiều ảnh:", err);
      toast.error("Có lỗi khi upload ảnh");
    }
  };

  const handleDelete = (index) => {
    const ids = [...(values[name] || [])];
    const previews = [...(values[`${name}Preview`] || [])];
    URL.revokeObjectURL(previews[index]?.url);
    ids.splice(index, 1);
    previews.splice(index, 1);
    setFieldValue(name, ids);
    setFieldValue(`${name}Preview`, previews);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        style={{
          padding: "6px 12px",
          backgroundColor: "#4276a4",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          whiteSpace: "nowrap",
          marginTop: "15px",
        }}
      >
        + Tải ảnh lên
      </button>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        hidden
        onChange={handleChange}
      />
      <LightGallery
        speed={500}
        plugins={[lgThumbnail, lgFullscreen, lgRotate]}
        elementClassNames="custom-lightgallery-wrapper"
      >
        {(values[`${name}Preview`] || []).map((item, index) => (
          <a
            key={item.id}
            href={item.url}
            style={{
              position: "relative",
              display: "inline-block",
              width: 70,
              height: 70,
              marginRight: 8,
              border: "1px solid #ccc",
              borderRadius: 4,
              overflow: "hidden",
            }}
          >
            <img
              src={item.url}
              alt={`img-${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleDelete(index);
              }}
              title="Xóa"
              style={{
                position: "absolute",
                top: 2,
                right: 2,
                border: "none",
                background: "transparent",
                fontSize: "14px",
                cursor: "pointer",
                color: "black",
              }}
            >
              ×
            </button>
          </a>
        ))}
      </LightGallery>
    </div>
  );
};

const DialogError = observer(({ values, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            setFieldValue("voucherDate", new Date());
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${values?.patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

export default memo(observer(PaymentVoucherPopup));
